import { r as o, c as l, h as s, H as h, g as c } from "./main-bb89b2f2.js";
import { t as d } from "./css-0ddb1002-1a05df0b.js";
import { g as p } from "./getHTMLElements-42e066e3-4491c4a7.js";
import "vue";
const f = "*,:after,:before{border-color:var(--color-neutral-steel-200);border-style:solid;border-width:0;box-sizing:border-box}a{color:inherit;text-decoration:inherit}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0}blockquote,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset,legend{padding:0}.sticky{position:sticky}.toc-heading{font-family:var(--copytext-font-family-bold);font-size:var(--copytext-font-size-small-noctx);line-height:var(--copytext-line-height-small-noctx);margin-bottom:8px;padding:0 8px}.toc-navigation{position:sticky;top:0}.visible{visibility:visible}.static{position:static}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}", g = f, v = class {
  constructor(t) {
    o(this, t), this.change = l(this, "lhChange", 7), this.activeChapter = null, this.heading = void 0, this.navigationStyles = void 0;
  }
  handleChapterClick(t) {
    t.stopImmediatePropagation(), this.change.emit({ value: t.detail.value });
  }
  async onActiveChapterChange(t) {
    await this.setActiveChapter(t);
  }
  async setActiveChapter(t) {
    const n = p(this.hostElement, "patternlib-table-of-contents-chapter-v1").map(async (a) => {
      if (a.value !== t)
        a.isActive = !1;
      else {
        a.isActive = !0;
        let i = a.parentElement;
        const e = (r) => r.nodeName === "PATTERNLIB-TABLE-OF-CONTENTS-CHAPTER-V1";
        for (; e(i); )
          await i.setExpansion(!0), i = i.parentElement;
      }
    });
    await Promise.all(n);
  }
  updateChapters(t = this.hostElement, n = 0) {
    const a = Array.from(t.children).filter((e) => e.nodeName === "PATTERNLIB-TABLE-OF-CONTENTS-CHAPTER-V1"), i = [];
    for (const e of a) {
      const r = this.updateChapters(e, n + 1);
      i.push({
        element: e,
        value: e.value,
        children: r,
        level: n
      }), e.level = n, e.isExpandable = r.length > 0;
    }
    return i;
  }
  async componentWillLoad() {
    this.activeChapter && await this.setActiveChapter(this.activeChapter), this.updateChapters();
  }
  render() {
    return s(h, { key: "f4765ebb083db0cd89fdd231736467b88b258bd6" }, s("slot", { key: "b64eedc32d67a64e8cf23f0635b33c731fe455fc", name: "title" }, this.heading && s("h1", { key: "deb29ed3a03dbf65dd2f6fb8c0a99c2b802c7e47", part: "heading", class: "toc-heading" }, this.heading)), s("nav", { key: "d3d25007141c63cb60585a5fb65f8514d117d914", part: "navigation", class: "toc-navigation", style: d(this.navigationStyles) }, s("slot", { key: "777e5719af1c442f3a4096c014f54380f1d9c0e0" })));
  }
  get hostElement() {
    return c(this);
  }
  static get watchers() {
    return {
      activeChapter: ["onActiveChapterChange"]
    };
  }
};
v.style = g;
export {
  v as patternlib_table_of_contents_v1
};
